var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7173 22.65H0V0H23.7173V22.65ZM2.27685 20.3731H21.4325V2.27686H2.27685",
    fill: "#2372BA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.7312 1.2175H22.7526V21.0689H1.7312V1.2175Z",
    fill: "#2372BA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0094 6.77524L16.5388 17.3057H13.6611L11.6847 11.2025L9.60544 17.3057H6.73565L3.5022 6.77524H6.45105L8.3326 13.5742L10.6332 6.77524H12.8784L15.013 13.5742L17.0685 6.77524H20.0094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word_icon.4a3f3ee72b209ce6b909664a8728446b.svg";
export { ForwardRef as ReactComponent };